export default __webpack_public_path__ + "static/media/correct-audio.62721562.wav";